/**
 * Brightcode size chart — sets mode.
 * Two-way sync with variant-picker; ATC + wishlist footer.
 * Keep this light: never observe checked attrs (that caused picker hangs).
 */
(function () {
  if (window.__bcSizeChartSetsV3) return;
  window.__bcSizeChartSetsV3 = true;

  var syncingFromChart = false;
  var userPicks = {}; // { chartName: size }

  function normalizeSize(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function tokenizeSize(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[()[\]{}]/g, ' ')
      .replace(/[^a-z0-9 ]+/g, ' ')
      .split(/\s+/)
      .filter(Boolean);
  }

  function sizesMatch(a, b) {
    var na = normalizeSize(a);
    var nb = normalizeSize(b);
    if (!na || !nb) return false;
    if (na === nb) return true;
    var ta = tokenizeSize(a);
    var tb = tokenizeSize(b);
    for (var i = 0; i < ta.length; i++) {
      for (var j = 0; j < tb.length; j++) {
        if (ta[i] === tb[j]) return true;
      }
    }
    return false;
  }

  function tokenize(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9 ]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function chartMatchesOption(chartName, optionName) {
    var ct = tokenize(chartName);
    var ot = tokenize(optionName);
    for (var i = 0; i < ot.length; i++) {
      if (!ot[i]) continue;
      if (ct.indexOf(ot[i]) !== -1) return true;
    }
    return false;
  }

  function inToCm(val) {
    if (val == null || val === '' || val === '—') return val;
    var s = String(val).trim();
    if (!s) return s;
    return s.replace(/(\d+(?:\.\d+)?)/g, function (n) {
      var cm = Math.round(parseFloat(n) * 2.54 * 10) / 10;
      return String(cm);
    });
  }

  function getVariantPicker() {
    return document.querySelector('variant-picker');
  }

  function getOptionFieldsets(vp) {
    if (!vp) return [];
    return Array.prototype.slice.call(
      vp.querySelectorAll('fieldset.variant-option, fieldset[class*="variant-option--"]')
    );
  }

  function getOptionNameFromFieldset(fs) {
    var nameEl = fs.querySelector('.variant-option__name, legend .variant-option__name');
    if (nameEl) return (nameEl.textContent || '').trim();
    var legend = fs.querySelector('legend');
    if (legend) {
      var clone = legend.cloneNode(true);
      clone.querySelectorAll('a, button, .popup-link, [data-bc-popup-proxy]').forEach(function (el) {
        el.remove();
      });
      return (clone.textContent || '').trim().replace(/\s+/g, ' ');
    }
    var m = (fs.className || '').match(/variant-option--([a-z0-9_-]+)/i);
    if (m) return m[1].charAt(0).toUpperCase() + m[1].slice(1);
    return '';
  }

  function parseManualMap(root) {
    var raw = root && root.getAttribute('data-bc-sc-variant-map');
    if (!raw) return {};
    var out = {};
    raw.split(/\r?\n/).forEach(function (line) {
      var idx = line.indexOf('=');
      if (idx === -1) return;
      var k = line.slice(0, idx).trim().toLowerCase();
      var v = line.slice(idx + 1).trim();
      if (k && v) out[k] = v;
    });
    return out;
  }

  function findChartByName(charts, name) {
    if (!name) return null;
    var target = String(name).trim().toLowerCase();
    return charts.find(function (c) {
      return (
        String(c.getAttribute('data-bc-sc-chart-name') || '')
          .trim()
          .toLowerCase() === target
      );
    });
  }

  function usableRadios(fs) {
    return Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')).filter(function (vr) {
      return String(vr.value || '').trim() !== '';
    });
  }

  function buildOptionToChartMap(root) {
    var vp = getVariantPicker();
    var fieldsets = getOptionFieldsets(vp);
    var charts = Array.prototype.slice.call(root.querySelectorAll('.bc-sc-chart'));
    var manualMap = parseManualMap(root);
    var map = [];
    var usedCharts = new Set();

    fieldsets.forEach(function (fs) {
      var optName = getOptionNameFromFieldset(fs);
      var key = optName.toLowerCase();
      if (manualMap[key]) {
        var hit = findChartByName(charts, manualMap[key]);
        if (hit && !usedCharts.has(hit)) {
          usedCharts.add(hit);
          map.push({ optionName: optName, fieldset: fs, chart: hit });
        }
      }
    });

    fieldsets.forEach(function (fs) {
      if (
        map.find(function (m) {
          return m.fieldset === fs;
        })
      )
        return;
      var optName = getOptionNameFromFieldset(fs);
      var hit = charts.find(function (c) {
        if (usedCharts.has(c)) return false;
        var cn = c.getAttribute('data-bc-sc-chart-name') || '';
        return chartMatchesOption(cn, optName);
      });
      if (hit) {
        usedCharts.add(hit);
        map.push({ optionName: optName, fieldset: fs, chart: hit });
      }
    });

    fieldsets.forEach(function (fs, idx) {
      if (
        map.find(function (m) {
          return m.fieldset === fs;
        })
      )
        return;
      var remaining = charts.filter(function (c) {
        return !usedCharts.has(c);
      });
      if (!remaining.length) return;
      var fsIdx = parseInt(fs.getAttribute('data-fieldset-index') || String(idx), 10);
      var picked =
        remaining.find(function (c) {
          var ci = parseInt(c.getAttribute('data-bc-sc-chart-index') || '', 10);
          return ci === fsIdx;
        }) || remaining[0];
      usedCharts.add(picked);
      map.push({ optionName: getOptionNameFromFieldset(fs), fieldset: fs, chart: picked });
    });

    return map;
  }

  /**
   * Horizon pill CSS needs data-current-checked / data-previous-checked.
   * Setting only `.checked` makes the LAST option look white/unselected.
   */
  function selectFieldsetRadio(fs, size, dispatchChange) {
    if (!fs || !size) return null;
    var radios = usableRadios(fs);
    var hit = null;
    radios.forEach(function (vr) {
      if (!hit && sizesMatch(vr.value, size)) hit = vr;
    });
    if (!hit) return null;

    // Already selected — avoid re-dispatch / thrash
    if (hit.checked && hit.getAttribute('data-current-checked') === 'true') {
      return hit;
    }

    var prev =
      fs.querySelector('input[type="radio"][data-current-checked="true"]') ||
      fs.querySelector('input[type="radio"]:checked');

    radios.forEach(function (vr) {
      var isHit = vr === hit;
      var isPrev = !!(prev && vr === prev && prev !== hit);
      vr.checked = isHit;
      vr.setAttribute('data-current-checked', isHit ? 'true' : 'false');
      vr.setAttribute('data-previous-checked', isPrev ? 'true' : 'false');
    });

    if (dispatchChange) {
      syncingFromChart = true;
      try {
        hit.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        setTimeout(function () {
          syncingFromChart = false;
        }, 200);
      }
    }
    return hit;
  }

  function applyChartHighlight(chart, size) {
    if (!chart) return;
    chart.querySelectorAll('.bc-sc-size-radio__input').forEach(function (r) {
      r.checked = false;
    });
    chart.querySelectorAll('.bc-sc-table__row').forEach(function (row) {
      row.classList.remove('is-selected');
    });
    if (!size) return;
    chart.querySelectorAll('.bc-sc-size-radio__input').forEach(function (r) {
      if (sizesMatch(r.value, size)) {
        r.checked = true;
        var row = r.closest('.bc-sc-table__row');
        if (row) row.classList.add('is-selected');
      }
    });
  }

  function annotateChartMappings(root) {
    var map = buildOptionToChartMap(root);
    map.forEach(function (entry) {
      var title = entry.chart.querySelector('.bc-sc-chart__title');
      if (!title) return;
      var caption = entry.chart.querySelector('.bc-sc-chart__mapping');
      if (!caption) {
        caption = document.createElement('div');
        caption.className = 'bc-sc-chart__mapping';
        title.insertAdjacentElement('afterend', caption);
      }
      caption.textContent = 'For variant option: ' + (entry.optionName || '—');
    });
  }

  function syncAvailability(root) {
    var map = buildOptionToChartMap(root);
    map.forEach(function (entry) {
      var unavailableLabels = [];
      usableRadios(entry.fieldset).forEach(function (vr) {
        var avail = vr.getAttribute('data-option-available');
        var disabled =
          vr.disabled || vr.getAttribute('aria-disabled') === 'true' || avail === 'false';
        if (disabled) unavailableLabels.push(vr.value);
      });
      entry.chart.querySelectorAll('.bc-sc-table__row').forEach(function (row) {
        var input = row.querySelector('.bc-sc-size-radio__input');
        if (!input) return;
        var isUnavail = unavailableLabels.some(function (lbl) {
          return sizesMatch(input.value, lbl);
        });
        if (isUnavail) {
          row.classList.add('is-unavailable');
          input.disabled = true;
          input.setAttribute('aria-disabled', 'true');
        } else {
          row.classList.remove('is-unavailable');
          input.disabled = false;
          input.removeAttribute('aria-disabled');
        }
      });
    });
  }

  function seedPicksFromPicker(root) {
    var map = buildOptionToChartMap(root);
    map.forEach(function (entry) {
      var chartName = entry.chart.getAttribute('data-bc-sc-chart-name') || '';
      var checked =
        entry.fieldset.querySelector('input[type="radio"][data-current-checked="true"]') ||
        entry.fieldset.querySelector('input[type="radio"]:checked');
      if (checked && String(checked.value || '').trim()) {
        userPicks[chartName] = checked.value;
      }
    });
  }

  function updateAtcBar(root) {
    var bar = root.querySelector('[data-bc-sc-atc-bar]');
    if (!bar) return;
    var sizeSpan = bar.querySelector('[data-bc-sc-atc-size]');
    var parts = [];
    Object.keys(userPicks).forEach(function (name) {
      if (userPicks[name]) parts.push(name + ' ' + userPicks[name]);
    });
    bar.hidden = false;
    if (sizeSpan) sizeSpan.textContent = parts.length ? parts.join(' · ') : '—';
  }

  function syncChartsFromPicks(root) {
    if (!root) return;
    root.querySelectorAll('.bc-sc-chart').forEach(function (chart) {
      var name = chart.getAttribute('data-bc-sc-chart-name') || '';
      applyChartHighlight(chart, userPicks[name] || null);
    });
    syncAvailability(root);
    annotateChartMappings(root);
    updateAtcBar(root);
  }

  function setUnit(root, unit) {
    root.querySelectorAll('[data-bc-sc-unit]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-bc-sc-unit') === unit);
    });
    root.querySelectorAll('[data-bc-sc-unit-label]').forEach(function (l) {
      l.textContent = unit;
    });
    root.querySelectorAll('[data-bc-sc-val]').forEach(function (cell) {
      var inVal = cell.getAttribute('data-bc-sc-in');
      cell.textContent = unit === 'cm' ? inToCm(inVal) : inVal;
    });
    root.setAttribute('data-bc-sc-active-unit', unit);
  }

  function closeHostPopup(root) {
    var host = root.closest('dialog-component, .popup-link');
    if (!host) return;
    if (typeof host.closeDialog === 'function') {
      host.closeDialog();
      return;
    }
    var dialog = host.querySelector('dialog');
    if (dialog && typeof dialog.close === 'function') dialog.close();
  }

  function applyPickToPicker(root, chartName, size) {
    var map = buildOptionToChartMap(root);
    var entry = map.find(function (m) {
      return (m.chart.getAttribute('data-bc-sc-chart-name') || '') === chartName;
    });
    if (!entry) return;
    userPicks[chartName] = size;
    applyChartHighlight(entry.chart, size);
    selectFieldsetRadio(entry.fieldset, size, true);
    updateAtcBar(root);
  }

  function flushAllPicks(root) {
    var map = buildOptionToChartMap(root);
    map.forEach(function (entry) {
      var chartName = entry.chart.getAttribute('data-bc-sc-chart-name') || '';
      var size = userPicks[chartName];
      if (!size) return;
      selectFieldsetRadio(entry.fieldset, size, true);
    });
  }

  function findPageAtcBtn() {
    var candidates = [
      'add-to-cart-component button[name="add"]',
      'product-form-component button[name="add"]',
      'product-form button[name="add"]',
      'form[action*="/cart/add"] button[name="add"]',
      'button[ref="addToCartButton"]',
      'button[name="add"]',
      '.add-to-cart-button',
    ];
    for (var i = 0; i < candidates.length; i++) {
      var nodes = document.querySelectorAll(candidates[i]);
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.hasAttribute('data-bc-sc-atc')) continue;
        if (n.closest && n.closest('[data-bc-size-chart]')) continue;
        if (n.offsetParent === null && !n.matches(':focus')) continue;
        return n;
      }
    }
    return null;
  }

  function reorderChartsByOptions(root) {
    var container = root.querySelector('[data-bc-sc-charts]');
    if (!container) return;
    var map = buildOptionToChartMap(root);
    if (!map.length) return;
    map.forEach(function (entry) {
      container.appendChild(entry.chart);
    });
    Array.prototype.slice.call(container.querySelectorAll('.bc-sc-chart')).forEach(function (chart) {
      if (
        map.find(function (m) {
          return m.chart === chart;
        })
      )
        return;
      container.appendChild(chart);
    });
  }

  function hideBlankOptionLabels() {
    document.querySelectorAll('fieldset.variant-option label.variant-option__button-label').forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      if (!input) return;
      if (String(input.value || '').trim() === '') {
        label.hidden = true;
        label.setAttribute('aria-hidden', 'true');
        label.style.display = 'none';
      }
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-bc-sc-mode') !== 'sets') return;
    hideBlankOptionLabels();
    reorderChartsByOptions(root);
    var defaultUnit = root.getAttribute('data-default-unit') || 'in';
    if (!root.getAttribute('data-bc-sc-active-unit')) setUnit(root, defaultUnit);
    seedPicksFromPicker(root);
    syncChartsFromPicks(root);
    root.dataset.bcScReady = '1';
  }

  function initAll(scope) {
    hideBlankOptionLabels();
    (scope || document).querySelectorAll('[data-bc-size-chart][data-bc-sc-mode="sets"]').forEach(initRoot);
  }

  document.addEventListener('click', function (e) {
    var unitBtn = e.target.closest && e.target.closest('[data-bc-sc-unit]');
    if (unitBtn) {
      var rootU = unitBtn.closest('[data-bc-size-chart]');
      if (!rootU || rootU.getAttribute('data-bc-sc-mode') !== 'sets') return;
      e.preventDefault();
      setUnit(rootU, unitBtn.getAttribute('data-bc-sc-unit'));
      return;
    }

    var anchor = e.target.closest && e.target.closest('[data-bc-sc-anchor]');
    if (anchor) {
      var rootA = anchor.closest('[data-bc-size-chart]');
      if (!rootA) return;
      e.preventDefault();
      var key = anchor.getAttribute('data-bc-sc-anchor');
      var body = rootA.querySelector('[data-bc-sc-body]');
      var section = rootA.querySelector('[data-bc-sc-section="' + key + '"]');
      rootA.querySelectorAll('[data-bc-sc-anchor]').forEach(function (t) {
        var on = t.getAttribute('data-bc-sc-anchor') === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      // Drop sticky mobile focus ring after tap
      if (anchor.blur) anchor.blur();
      if (section && body) {
        body.scrollTo({ top: Math.max(0, section.offsetTop - body.offsetTop), behavior: 'smooth' });
      }
      return;
    }

    var row = e.target.closest && e.target.closest('[data-bc-sc-row]');
    if (row) {
      if (e.target.closest('a, button, select, textarea')) return;
      var input = row.querySelector('.bc-sc-size-radio__input');
      if (!input || input.disabled) return;
      var rootR = row.closest('[data-bc-size-chart]');
      if (!rootR || rootR.getAttribute('data-bc-sc-mode') !== 'sets') return;
      applyPickToPicker(rootR, input.getAttribute('data-bc-sc-chart') || '', input.value);
      return;
    }

    var atcBtn = e.target.closest && e.target.closest('[data-bc-sc-atc]');
    if (atcBtn) {
      e.preventDefault();
      var rootAtc = atcBtn.closest('[data-bc-size-chart]');
      if (!rootAtc) return;
      flushAllPicks(rootAtc);
      setTimeout(function () {
        var pageBtn = findPageAtcBtn();
        if (pageBtn) pageBtn.click();
        else {
          var form = document.querySelector(
            'product-form-component form, product-form form, form[action*="/cart/add"]'
          );
          if (form && form.requestSubmit) form.requestSubmit();
          else if (form) form.submit();
        }
        closeHostPopup(rootAtc);
      }, 100);
    }
  });

  // PDP chip click → update chart only (never rewrite picker attrs here)
  document.addEventListener(
    'click',
    function (e) {
      if (syncingFromChart) return;
      var label =
        e.target &&
        e.target.closest &&
        e.target.closest('.variant-option__button-label, .variant-option label');
      if (!label) return;
      var input = label.querySelector('input[type="radio"]');
      if (!input || String(input.value || '').trim() === '') return;
      var fs = label.closest('fieldset.variant-option, fieldset[class*="variant-option--"]');
      if (!fs) return;
      setTimeout(function () {
        document.querySelectorAll('[data-bc-size-chart][data-bc-sc-mode="sets"]').forEach(function (root) {
          var map = buildOptionToChartMap(root);
          var entry = map.find(function (m) {
            return m.fieldset === fs;
          });
          if (!entry) return;
          var chartName = entry.chart.getAttribute('data-bc-sc-chart-name') || '';
          userPicks[chartName] = input.value;
          applyChartHighlight(entry.chart, input.value);
          updateAtcBar(root);
        });
      }, 0);
    },
    false
  );

  // PDP change → chart highlight only
  document.addEventListener(
    'change',
    function (e) {
      if (syncingFromChart) return;
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      if (!t.closest || !t.closest('variant-picker')) return;
      var fs = t.closest('fieldset.variant-option, fieldset[class*="variant-option--"]');
      if (!fs || String(t.value || '').trim() === '') return;
      document.querySelectorAll('[data-bc-size-chart][data-bc-sc-mode="sets"]').forEach(function (root) {
        var map = buildOptionToChartMap(root);
        var entry = map.find(function (m) {
          return m.fieldset === fs;
        });
        if (!entry) return;
        var chartName = entry.chart.getAttribute('data-bc-sc-chart-name') || '';
        userPicks[chartName] = t.value;
        applyChartHighlight(entry.chart, t.value);
        updateAtcBar(root);
      });
    },
    true
  );

  document.addEventListener(
    'toggle',
    function (e) {
      if (!e.target || e.target.tagName !== 'DIALOG') return;
      if (!e.target.open) return;
      var root = e.target.querySelector('[data-bc-size-chart][data-bc-sc-mode="sets"]');
      if (!root) return;
      hideBlankOptionLabels();
      reorderChartsByOptions(root);
      seedPicksFromPicker(root);
      syncChartsFromPicks(root);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
